import React, {useContext} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {getStoreConfig} from "../../../../services/Store/reducer";
import {RootState} from "../../../../../reducers";
import {ReactComponent as SearchSVG} from "../../../../../images/icons/search.svg";
import {ReactComponent as RemoveIco} from "../../../../../images/icons/remove.svg";
import {MenuSearchContext} from "../../../../services/Menu/services/Search/MenuSearchContext";

interface OwnProps {
    hideOnClear?: true;
}

type Props = ReturnType<typeof mapStateToProps> & DispatchProp & OwnProps;

const MenuSearchFilterComponent = (props: Props) => {
    const {t} = useTranslation();
    const {search, setSearch, setShowSearchBar} = useContext(MenuSearchContext);

    if (!props.config) return null;

    const handleSearch = (value?: string) => {
        setSearch(value ?? "");
    }

    const handleClearSearch = () => {
        setSearch("");
        if (props.hideOnClear) {
            setShowSearchBar(false);
        }
    }

    return (
        <div className={"container-fluid"}>
            <div className="input-search menu-filters">
                <input type="text" className="form-control" placeholder={t("modules.menu.field.search_product.title")}
                       value={search}
                       onChange={(e) => handleSearch(e.target.value)}/>
                <SearchSVG className={"left"}/>
                {
                    search && (
                        <div className={"right text-muted"} onClick={handleClearSearch}>
                            <RemoveIco/>
                        </div>
                    )
                }
            </div>
        </div>
    )

}


const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuSearchFilterComponent));